/* ── RapTV Admin Global State (ES Module) ── */

// State variables (exported as live bindings)
export let catalog = [];
export let channels = []; 
export let templates = []; // Storage for dynamic CRT templates
export let selectedChannel = 0;
export let _scheduleVisible = false;
export let _minioPrefix = '';
export let _minioAllTags = {};
export let _minioSearchTimer = null;
export let editingVideoIndex = null;
export let originalVideoSnapshot = null;
export let ytFetcherReady = false;
export let ytFetcher = null;
export let currentUser = null;
export let _scheduleTimer = null;
export let _scheduleNowMap = {};
export let onDurationFetched = null;
export let returnToSearch = false;

// UI States
export let currentChannel = 0;
export let currentVideo = 0;
export let isAdminMode = true;

/**
 * Función central para actualizar el estado global desde cualquier módulo.
 */
export function updateState(key, value) {
  switch(key) {
    case 'catalog': catalog = value; break;
    case 'channels': channels = value; break;
    case 'templates': templates = value; break;
    case 'selectedChannel': selectedChannel = value; break;
    case 'currentUser': currentUser = value; break;
    case 'ytFetcher': ytFetcher = value; break;
    case 'ytFetcherReady': ytFetcherReady = value; break;
    case 'editingVideoIndex': editingVideoIndex = value; break;
    case 'originalVideoSnapshot': originalVideoSnapshot = value; break;
    case 'onDurationFetched': onDurationFetched = value; break;
    case 'currentChannel': currentChannel = value; break;
    case 'currentVideo': currentVideo = value; break;
    case 'isAdminMode': isAdminMode = value; break;
    case '_scheduleVisible': _scheduleVisible = value; break;
    case '_scheduleTimer': _scheduleTimer = value; break;
    case '_scheduleNowMap': _scheduleNowMap = value; break;
    case '_minioPrefix': _minioPrefix = value; break;
    case '_minioAllTags': _minioAllTags = value; break;
    case '_minioSearchTimer': _minioSearchTimer = value; break;
    case 'returnToSearch': returnToSearch = value; break;
    default:
      console.warn(`Estado no reconocido o no mutable: ${key}`);
  }
}
